"use client";

import { useEffect } from "react";
import { getCookie, setCookie } from "utils/cookies";
const whitelistUTMSources = ["cj"];
export default function ExtensionsUISupressor({
  interval = 3000 // ms between cleanup runs
}: {
  interval?: number;
}) {
  useEffect(() => {
    const isWhitelisted = getCookie("wlextensions"); // whitelistextensions
    if (isWhitelisted) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.has("utm_source")) {
      const source = params.get("utm_source") || "";
      if (whitelistUTMSources.includes(source)) {
        setCookie("wlextensions", "true"); // Pass no expiry to keep it for a session
        return;
      }
    }
    const isSuspicious = (el: HTMLElement) => el.tagName !== "HEAD" && el.tagName !== "BODY" && el.style.all === "initial";
    const clean = () => {
      Array.from(document.documentElement.children).forEach(el => {
        if (el instanceof HTMLElement && isSuspicious(el)) {
          el.remove();
        }
      });
    };

    // Run once on mount
    clean();

    // Watch for new injected nodes
    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node instanceof HTMLElement && node.parentNode === document.documentElement && isSuspicious(node)) {
            node.remove();
          }
        }
      }
    });

    // Observe the root(html) element
    observer.observe(document.documentElement, {
      childList: true
    });

    // Fallback interval cleanup
    const timer = window.setInterval(clean, interval);
    return () => {
      observer.disconnect();
      window.clearInterval(timer);
    };
  }, [interval]);
  return null;
}